import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Prism from "prismjs"
import '../css/style.css'
import "prismjs/themes/prism-tomorrow.css";
import 'prismjs/components/prism-python';
import "prismjs/plugins/toolbar/prism-toolbar"
import "prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard"

export default function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
      Prism.highlightAll();
  }, [pathname]);

  return null;
}